(function () {
  'use strict';

  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

    var data = {
      navigation: {
        "dashboard": "Početna strana",
        "accountsAndCards": "Računi i Kartice",
        "accounts": "Računi",
        "payments": "Plaćanja",
        "deposit": "Štednja",
        "loans": "Krediti",
        "investments": "Investicije",
        "settings": "Podešavanja",
        "messages": "Poruke",
        "hypoClub": "Addiko Club",
        "eTrade": "Addiko ETrade",
        "paymentsAndTransfers" :"Pregled plaćanja i prenosa",
        "domesticPayment": "Nalog za plaćanje",
        "transferToMyAccount": "Prenos na moj račun",
        "internationalPayment": "Internacionalno plaćanje",
        "exchangeOffice" :"Razmena valute",
        "exchangeRates" :"Kursna lista",
        "standingOrders": "Trajni nalog",
        "eInvoices": "eRačuni",
        "paymentsList": "Lista plaćanja",
        "paymentsReturn": "Povrat plaćanja",
        "directDebitsList": "Lista SEPA izravnih dugovanja",
        "myTemplatesList": "Moji šabloni",
        "allAccountsOverview": "Pregled svih računa",
        "allDepositOverview": "Sve štednje",
        "allDeposits": "Štednje",
        "allDepositOverviewSerbMne": "Štednja",
        "loansOverview": "Pregled kredita",
        "investmentsOverview": "Pregled investicija",
        "availableBalance": "Raspoloživi iznos",
        "loanBalance": "Stanje kredita",
        "newMessages": "Nove poruke: ",
        "allowedLoan":"Odobreni iznos",
        "balance": "Stanje računa",
        "newOrder":"Kupnja udjela",
        "viberBanking":"Addiko Chat Banking"
      }
    };

    $translateProvider
      .translations('mne', data);

  }
}());

